import { Card, CardContent } from "./ui/card";
import { motion } from "framer-motion";
import { TrendingUp, Users, Zap } from "lucide-react";

export function CaseStudiesSection() {
  const caseStudies = [
    {
      title: "TechGear VN - Digital Campaign",
      category: "Digital Marketing",
      description: "Integrated Facebook and Google Ads campaign for tech products with remarkable results",
      image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=500&h=300&fit=crop",
      metrics: [
        { icon: TrendingUp, label: "ROAS", value: "4.2x" },
        { icon: Users, label: "Reach", value: "2.5M" },
        { icon: Zap, label: "Conversion", value: "+180%" }
      ],
      color: "orange-600"
    },
    {
      title: "ProBeauty - Brand Activation",
      category: "Offline & Events",
      description: "Product launch event with roadshow across 5 major cities driving brand awareness",
      image: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=500&h=300&fit=crop",
      metrics: [
        { icon: Users, label: "Participants", value: "15K+" },
        { icon: TrendingUp, label: "Brand Awareness", value: "+65%" },
        { icon: Zap, label: "Sales Lift", value: "+90%" }
      ],
      color: "orange-500"
    },
    {
      title: "Café Bông Sen - Tech Solution",
      category: "A+ Content Hub",
      description: "Automated content management system with advanced marketing performance analytics",
      image: "https://images.unsplash.com/photo-1559056199-641a0ac8b55e?w=500&h=300&fit=crop",
      metrics: [
        { icon: Zap, label: "Content Efficiency", value: "+250%" },
        { icon: TrendingUp, label: "Time Saved", value: "60%" },
        { icon: Users, label: "User Engagement", value: "+120%" }
      ],
      color: "orange-700"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Case Studies
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-orange-500 to-orange-700 mx-auto mb-8"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Successful projects delivered in partnership with our clients
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {caseStudies.map((study, index) => (
            <motion.div
              key={study.title}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: index * 0.2 }}
              viewport={{ once: true }}
            >
              <Card className="h-full overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border-0">
                <div className="relative overflow-hidden">
                  <img 
                    src={study.image} 
                    alt={study.title}
                    className="w-full h-48 object-cover transition-transform duration-300 hover:scale-110"
                  />
                  <div className={`absolute top-4 left-4 px-3 py-1 rounded-full text-white text-sm font-medium ${
                    study.color === 'orange-600' ? 'bg-orange-600' :
                    study.color === 'orange-500' ? 'bg-orange-500' : 'bg-orange-700'
                  }`}>
                    {study.category}
                  </div>
                </div>
                <CardContent className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    {study.title}
                  </h3>
                  <p className="text-gray-600 mb-6 leading-relaxed">
                    {study.description}
                  </p>
                  <div className="grid grid-cols-3 gap-4">
                    {study.metrics.map((metric, metricIndex) => (
                      <div key={metricIndex} className="text-center">
                        <div className={`inline-flex p-2 rounded-full mb-2 ${
                          study.color === 'orange-600' ? 'bg-orange-100' :
                          study.color === 'orange-500' ? 'bg-orange-100' : 'bg-orange-100'
                        }`}>
                          <metric.icon className={`w-4 h-4 ${
                            study.color === 'orange-600' ? 'text-orange-600' :
                            study.color === 'orange-500' ? 'text-orange-500' : 'text-orange-700'
                          }`} />
                        </div>
                        <div className="text-2xl font-bold text-gray-900">{metric.value}</div>
                        <div className="text-sm text-gray-600">{metric.label}</div>
                      </div>
                    ))}
                  </div>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}